import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/styles/HowItWorks.scss";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import MemoryIcon from "@mui/icons-material/Memory";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const steps = [
  {
    icon: <CloudSyncIcon />,
    title: "Collect",
    description:
      "We pull live data from matches across hundreds of leagues worldwide — goals, shots, cards, corners, and momentum — updated in real time.",
  },
  {
    icon: <MemoryIcon />,
    title: "Process",
    description:
      "Guru Vision, our AI analysis model, processes live stats alongside recent form and head-to-head history to build a clear picture of the match.",
  },
  {
    icon: <FilterAltIcon />,
    title: "Filter",
    description:
      "Your Smart Alert conditions and personalization settings filter that data down to the specific patterns and matches you actually follow.",
  },
  {
    icon: <NotificationsActiveIcon />,
    title: "Deliver",
    description:
      "The moment your conditions are met, you get a notification — no refreshing, no noise, just the insight you set up.",
  },
];

function HowItWorks() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <div className="howitworks-outer" id="how-it-works">
      <div className="howitworks-header" data-aos="fade-up">
        <span className="section-eyebrow">How It Works</span>
        <h2 className="section-title">From Live Match Data to Personalized Insight</h2>
        <p className="section-description">
          A simple pipeline running behind every Smart Alert, every stat
          screen, and every notification.
        </p>
      </div>

      <div className="howitworks-grid">
        {steps.map((step, index) => (
          <div
            className="step-card"
            key={step.title}
            data-aos="fade-up"
            data-aos-delay={100 + index * 100}
          >
            <span className="step-number">{String(index + 1).padStart(2, "0")}</span>
            <div className="step-icon">{step.icon}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HowItWorks;
